import { MeetingsValue } from "../../../services/api/instances/meetingsApi/types";

export const getUpdatedMeetingValue = (
  value: MeetingsValue,
  fields: Partial<MeetingsValue["meetings_object"]>
): MeetingsValue => ({
  meetings_object: {
    ...value.meetings_object,
    ...fields,
  },
});
